/*
 * @Author: swmonk
 * @Date: 2020-11-23 10:07:01
 * @LastEditTime: 2020-11-24 15:12:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ufun-new-bc/src/index.js
 */
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import api from './net/api';
import * as serviceWorker from './serviceWorker';
import util from './util';

window.$api = api
window.$util = util

ReactDOM.render(<App/>,document.getElementById('root'));
serviceWorker.unregister();
